export default __webpack_public_path__ + "static/media/bars.751755ab.svg";